import { Middleware } from '@nuxt/types';
import { MBOOKS_STORE_CODE, PAYWALL_STORE_CODE, RINNOVI_STORE_CODE, SOLEPRO_STORE_CODE  } from '~/utils/constants/store';

/** Route Names */
const routes = {
  detailProduct:'detailProduct',
  feed:'mbooks_feed',
  prodotti:'rinnovi_prodotti',
  rinnovi:'Rinnovi',
  librerie:'librerie',
  hub: 'hub',
  home:'home'
}

const FORBIDDEN_ROUTES = {
  [SOLEPRO_STORE_CODE]: [routes.prodotti, routes.detailProduct, routes.feed, routes.rinnovi],
  [MBOOKS_STORE_CODE]: [routes.librerie, routes.hub, routes.prodotti, routes.detailProduct, routes.rinnovi, routes.home],
  [RINNOVI_STORE_CODE]: [routes.librerie, routes.hub, routes.feed],
  [PAYWALL_STORE_CODE]: [routes.librerie, routes.hub, routes.feed,routes.rinnovi]
}
const middleware : Middleware = (context) => {
  const storeCode = context.i18n.locale;
  const { route: { name }, redirect } = context;
  const isForbidden = FORBIDDEN_ROUTES[storeCode].find(forbiddenRoute => name.replace(`___${storeCode}`,'')==forbiddenRoute)
  if (isForbidden) {
    return redirect(`${storeCode==PAYWALL_STORE_CODE ? '': '/'+storeCode}/404`)
  }
};

export default middleware;
